import { render } from "./VariablePicker.vue?vue&type=template&id=124f58fc&scoped=true&ts=true"
import script from "./VariablePicker.vue?vue&type=script&lang=ts"
export * from "./VariablePicker.vue?vue&type=script&lang=ts"

import "./VariablePicker.vue?vue&type=style&index=0&id=124f58fc&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-124f58fc"]])

export default __exports__